import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import WebAppComp from './WebAppComp';
import foodapp from '../assets/images/foodapp.png';
import ecommerce from '../assets/images/ecommerce-app.png';
import clothapp from '../assets/images/clothapp.png';
import winter from '../assets/images/winter.png'

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box className='tabhaed'>
        <span className='filtertext'>Filters :</span>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Websites" {...a11yProps(0)} />
          <Tab label="Mobile Applications" {...a11yProps(1)} />
          <Tab label="Sort By : Newest" {...a11yProps(2)} />
        </Tabs>

      </Box>
      <CustomTabPanel value={value} index={0}>   
      <WebAppComp webappImg={foodapp} webtitle='Food Application UI' sum1='Web and Mobile Design' sum2='Content Strategy' sum3='CMS Integration' beni1='Unify your entire organizations' beni2='Data into a single' beni3='Centralized point of focus' />

      <WebAppComp webappImg={ecommerce} webtitle='Ecommerce Application Theme' sum1='Web and Mobile Design' sum2='Content Strategy' sum3='CMS Integration' beni1='Unify your entire organizations' beni2='Data into a single' beni3='Centralized point of focus' />

      <WebAppComp webappImg={clothapp} webtitle='Food Application UI' sum1='Web and Mobile Design' sum2='Content Strategy' sum3='CMS Integration' beni1='Unify your entire organizations' beni2='Data into a single' beni3='Centralized point of focus' />

      <WebAppComp webappImg={winter} webtitle='Ecommerce Application Theme' sum1='Web and Mobile Design' sum2='Content Strategy' sum3='CMS Integration' beni1='Unify your entire organizations' beni2='Data into a single' beni3='Centralized point of focus' />

      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
      <WebAppComp webappImg={foodapp} webtitle='Food Application UI' sum1='Web and Mobile Design' sum2='Content Strategy' sum3='CMS Integration' beni1='Unify your entire organizations' beni2='Data into a single' beni3='Centralized point of focus' />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        Item Three
      </CustomTabPanel>
    </Box>
  );
}